import {
  GretaAIChat,
  GretaAIChatContext,
  useGretaAIChatSession,
} from '../../../GretaAIChat'
import { GretaAIActionButton } from '../GretaAIActionButton'

function LayoutOverlayGretaAIChat({ displayName }) {
  const gretaAIChat = useGretaAIChatSession({ displayName })

  const { hasUnread, isLocked, launcherRef, onOpen } = gretaAIChat.launcher

  return (
    <>
      <GretaAIActionButton
        elementRef={launcherRef}
        hasUnread={hasUnread}
        isLocked={isLocked}
        onClick={onOpen}
      />
      <GretaAIChatContext value={gretaAIChat}>
        <GretaAIChat />
      </GretaAIChatContext>
    </>
  )
}

export default LayoutOverlayGretaAIChat
